import React, { memo } from 'react'
import './MenuDivider.scss'

export const MenuDivider = memo(function MenuDivider () {
  return (
    <div className="menu-divider"></div>
  )
})
